<template>
    <div class="equipment-edit">

        <data-form ref="equipment_dataform"
                   :auto-save="true"
                   :title="`Edit Equipment${vehicleId ? (': ' + vehicleId) : ''}`"
                   tag="equipment-edit-title"
                   :field-model="equipFields"
                   :field-groups="fieldGroups"
                   :field-group-tabs="fieldGroupTabs"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   cancelRoute="/equipment/list"
                   submit-success-message="Equipment updated"
                   submit-error-message="Error updating equipment"
                   :submit-success-route="`/equipment/view/${equipmentId}`"
                   v-on:changed="formChanged">
        </data-form>

        <b-row class="mt-3 pb-0">
            <b-col class="justify-content-end d-flex align-items-center flex-column">
                <p class="mb-2 text-light">Having trouble with your equipment registration?</p>
                <b-btn @click="showMessageModal()" variant="warning">
                    Request Assistance
                    <b-icon-box-arrow-right/>
                </b-btn>
            </b-col>
        </b-row>

        <message-create-modal :modalId="modalId" :recipient="appAdmin"/>

        <attachment-list class="mt-5"
                         model-class="Equipment"
                         model-table="equipment"
                         help-tag="equipment-upload"
                         :model-id="equipmentId"
                         :readOnly="false"/>

        <h3 class="mt-5">Activity Log</h3>

        <log-entries table="equipment" :model-instance-id="equipmentId"/>

    </div>
</template>

<script>

import Vue from 'vue'
import EquipmentFields from '@/models/Equipment'

/**
 * Page for admin to edit equipment
 */
export default Vue.extend({
    name: 'EquipmentEdit',
    props: {
        equipmentId: Number,
    },
    data () {
        return {
            vehicleId: null,
            equipFields: EquipmentFields,
            appAdmin: null,

            fieldGroupTabs: [
                { title: 'Identification' },
                { title: 'Category', lockedBy: [0] },
                { title: 'Details', lockedBy: [0, 1] },
                { title: 'Engine Details', lockedBy: [0, 1], hideIf: 'uncovered' },
                { title: 'Retrofit Status', lockedBy: [0, 1], hideIf: 'uncovered' },
            ],
            fieldGroups: [
                [
                    'vehicle_id',
                    'notes',
                ],
                [
                    'on_road',
                    'fuel_type',
                    'horsepower_level',
                    'type_onroad',
                    'type_nonroad'
                ],
                [
                    'license',
                    'vin',
                    'equipment_serial_number',
                    'equipment_model_year',
                    'equipment_manufacturer',
                    'equipment_model',
                ],
                [
                    'engineFamily',
                    'engine_family_name', // hidden but necessary (see models/Equipment.js)
                    'engine_tier',
                    'engine_manufacturer',
                    'engine_model_year',
                    'engine_hp',
                    'engine_model',
                    'engine_serial_number',
                ],
                [
                    'exhaust_retrofit_type',
                    'retrofit_manufacturer_id',
                    'retrofit_device_id',
                    'retrofit_serial_number',
                    'retrofit_installation_year'
                ]
            ],
        }
    },
    computed: {
        hash () {
            return Math.random().toString(36).substr(2, 5)
        },
        modalId () {
            return 'message_modal' + this.hash
        },
    },
    created () {
        this.getAppAdmin()
    },
    async mounted () {
        await this.$nextTick()
        this.$refs.equipment_dataform.$v.$touch()
    },
    methods: {
        async loadModelInstance () {
            const item = await this.$api.getItem(this, 'equipment', this.equipmentId, ['userLogs'])
            this.vehicleId = item.vehicle_id
            return item
        },
        onSubmit (modelInstance, $vform, isValid) {
            modelInstance.is_valid = +isValid
            return this.$api.updateItem(this, 'equipment', modelInstance, false) // don't log autosaves
        },
        formChanged (fieldName, form) {
            if (fieldName === 'vehicle_id') {
                this.vehicleId = form[fieldName]
            }
        },
        showMessageModal () {
            this.$bvModal.show(this.modalId)
        },
        async getAppAdmin () {
            const response = await this.$api.getAppAdmin()
            this.appAdmin = response.body
        },
    },
})

</script>

<style lang="scss">
    .equipment-edit {
        @media(min-width: 768px) {
            .tab-pane, .tab-pane.active {
                display: flex;
                justify-content: space-between;
                //align-items: baseline;
                flex-wrap: wrap;

                .data-form-input {
                    width: 49%;
                }
            }

            .tab-pane:nth-child(2) {
                display: block;

                .data-form-input {
                    width: 100%;
                }
            }

            .tab-pane:nth-child(4) {
                .data-form-input {
                    width: 32%;
                }
            }

            .tab-pane:nth-child(5) {
                .data-form-input {
                    width: 32%;
                }

                .data-form-input:first-child {
                    width: 100%;
                }
            }
        }

        .card-header .btn {
            border: none !important;
        }
    }
</style>